// ============================================
// DATA LOADER — vemprailhadomel.com.br
// Importa todos os JSONs e expõe funções de acesso
// Suporta i18n: merge pt-BR (base) + tradução do idioma ativo
// ============================================

// @ts-ignore
import praiasData from './praias.json';
// @ts-ignore
import trilhasData from './trilhas.json';
// @ts-ignore
import atracoesData from './atracoes.json';
// @ts-ignore
import passeiosData from './passeios.json';
// @ts-ignore
import pousadasData from './pousadas.json';
// @ts-ignore
import restaurantesData from './restaurantes.json';
// @ts-ignore
import baresData from './bares.json';
// @ts-ignore
import morrosData from './morros.json';
// @ts-ignore
import vilasData from './vilas.json';
// @ts-ignore
import ilhasData from './ilhas.json';
// @ts-ignore
import trapichesData from './trapiches.json';

// Traduções ES
// @ts-ignore
import praiasEs from './locales/es/praias.json';
// @ts-ignore
import trilhasEs from './locales/es/trilhas.json';
// @ts-ignore
import atracoesEs from './locales/es/atracoes.json';
// @ts-ignore
import passeiosEs from './locales/es/passeios.json';
// @ts-ignore
import pousadasEs from './locales/es/pousadas.json';
// @ts-ignore
import restaurantesEs from './locales/es/restaurantes.json';
// @ts-ignore
import morrosEs from './locales/es/morros.json';
// @ts-ignore
import vilasEs from './locales/es/vilas.json';
// @ts-ignore
import ilhasEs from './locales/es/ilhas.json';
// @ts-ignore
import trapichesEs from './locales/es/trapiches.json';

// Traduções EN
// @ts-ignore
import praiasEn from './locales/en/praias.json';
// @ts-ignore
import trilhasEn from './locales/en/trilhas.json';
// @ts-ignore
import atracoesEn from './locales/en/atracoes.json';
// @ts-ignore
import passeiosEn from './locales/en/passeios.json';
// @ts-ignore
import pousadasEn from './locales/en/pousadas.json';
// @ts-ignore
import restaurantesEn from './locales/en/restaurantes.json';
// @ts-ignore
import morrosEn from './locales/en/morros.json';
// @ts-ignore
import vilasEn from './locales/en/vilas.json';
// @ts-ignore
import ilhasEn from './locales/en/ilhas.json';
// @ts-ignore
import trapichesEn from './locales/en/trapiches.json';

// Traduções DE
// @ts-ignore
import praiasDe from './locales/de/praias.json';
// @ts-ignore
import trilhasDe from './locales/de/trilhas.json';
// @ts-ignore
import atracoesDe from './locales/de/atracoes.json';
// @ts-ignore
import passeiosDe from './locales/de/passeios.json';
// @ts-ignore
import pousadasDe from './locales/de/pousadas.json';
// @ts-ignore
import restaurantesDe from './locales/de/restaurantes.json';
// @ts-ignore
import morrosDe from './locales/de/morros.json';
// @ts-ignore
import vilasDe from './locales/de/vilas.json';
// @ts-ignore
import ilhasDe from './locales/de/ilhas.json';
// @ts-ignore
import trapichesDe from './locales/de/trapiches.json';

// Traduções FR
// @ts-ignore
import praiasFr from './locales/fr/praias.json';
// @ts-ignore
import trilhasFr from './locales/fr/trilhas.json';
// @ts-ignore
import atracoesFr from './locales/fr/atracoes.json';
// @ts-ignore
import passeiosFr from './locales/fr/passeios.json';
// @ts-ignore
import pousadasFr from './locales/fr/pousadas.json';
// @ts-ignore
import restaurantesFr from './locales/fr/restaurantes.json';
// @ts-ignore
import morrosFr from './locales/fr/morros.json';
// @ts-ignore
import vilasFr from './locales/fr/vilas.json';
// @ts-ignore
import ilhasFr from './locales/fr/ilhas.json';
// @ts-ignore
import trapichesFr from './locales/fr/trapiches.json';

import type { Lang } from '@/hooks/useI18n';

// Dados base pt-BR
const baseMap: Record<string, any[]> = {
  praia: praiasData as any[],
  trilha: trilhasData as any[],
  atracao: atracoesData as any[],
  passeio: passeiosData as any[],
  pousada: pousadasData as any[],
  restaurante: restaurantesData as any[],
  bar: baresData as any[],
  morro: morrosData as any[],
  vila: vilasData as any[],
  ilha: ilhasData as any[],
  trapiche: trapichesData as any[],
};

// Mapa de traduções por idioma
const translations: Record<Lang, Record<string, any[]>> = {
  'pt-BR': {},
  es: {
    praia: praiasEs as any[],
    trilha: trilhasEs as any[],
    atracao: atracoesEs as any[],
    passeio: passeiosEs as any[],
    pousada: pousadasEs as any[],
    restaurante: restaurantesEs as any[],
    bar: baresData as any[],
    morro: morrosEs as any[],
    vila: vilasEs as any[],
    ilha: ilhasEs as any[],
    trapiche: trapichesEs as any[],
  },
  en: {
    praia: praiasEn as any[],
    trilha: trilhasEn as any[],
    atracao: atracoesEn as any[],
    passeio: passeiosEn as any[],
    pousada: pousadasEn as any[],
    restaurante: restaurantesEn as any[],
    bar: baresData as any[],
    morro: morrosEn as any[],
    vila: vilasEn as any[],
    ilha: ilhasEn as any[],
    trapiche: trapichesEn as any[],
  },
  de: {
    praia: praiasDe as any[],
    trilha: trilhasDe as any[],
    atracao: atracoesDe as any[],
    passeio: passeiosDe as any[],
    pousada: pousadasDe as any[],
    restaurante: restaurantesDe as any[],
    bar: baresData as any[],
    morro: morrosDe as any[],
    vila: vilasDe as any[],
    ilha: ilhasDe as any[],
    trapiche: trapichesDe as any[],
  },
  fr: {
    praia: praiasFr as any[],
    trilha: trilhasFr as any[],
    atracao: atracoesFr as any[],
    passeio: passeiosFr as any[],
    pousada: pousadasFr as any[],
    restaurante: restaurantesFr as any[],
    bar: baresData as any[],
    morro: morrosFr as any[],
    vila: vilasFr as any[],
    ilha: ilhasFr as any[],
    trapiche: trapichesFr as any[],
  },
};

/** Faz merge de uma entidade base com sua tradução (match por handle) */
function mergeEntity(base: any, trans: any): any {
  if (!trans) return base;
  return { ...base, ...trans };
}

/** Retorna dados de uma categoria no idioma solicitado (fallback pt-BR) */
function getData(category: string, lang: Lang = 'pt-BR'): any[] {
  const base = baseMap[category] || [];
  if (lang === 'pt-BR') return base;
  const transList = translations[lang]?.[category];
  if (!transList) return base;
  const transMap = new Map(transList.map((t: any) => [t.handle, t]));
  return base.map((e: any) => mergeEntity(e, transMap.get(e.handle)));
}

/** Retorna todas as entidades de uma categoria */
export function getAll(category: string, lang?: Lang): any[] {
  return getData(category, lang);
}

/** Retorna apenas publicadas */
export function getPublished(category: string, lang?: Lang): any[] {
  return getData(category, lang).filter((e: any) => e.status === 'published');
}

/** Busca por handle */
export function getByHandle(category: string, handle: string, lang?: Lang): any | undefined {
  return getData(category, lang).find((e: any) => e.handle === handle);
}

/** Busca por ID */
export function getById(category: string, id: string, lang?: Lang): any | undefined {
  return getData(category, lang).find((e: any) => e.id === id);
}

/** Filtra por vilarejo */
export function getByVilarejo(category: string, vilarejo: string, lang?: Lang): any[] {
  return getData(category, lang).filter((e: any) => e.vilarejo === vilarejo);
}

/** Busca por texto */
export function search(category: string, query: string, lang?: Lang): any[] {
  const q = query.toLowerCase();
  return getData(category, lang).filter((e: any) => {
    const text = [e.title, e.subtitle, e.description, ...(e.highlights || []), ...(e.tips || [])]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    return text.includes(q);
  });
}

/** Retorna entidades relacionadas */
export function getRelated(category: string, entity: any, limit = 3, lang?: Lang): any[] {
  const list = getData(category, lang);
  const nearbyIds = entity.nearbyAttractions || [];
  const byNearby = list.filter(
    (e: any) => nearbyIds.includes(e.id) || nearbyIds.includes(e.handle)
  );
  const byVilarejo = list.filter((e: any) => e.vilarejo === entity.vilarejo && e.id !== entity.id);
  const combined = [...byNearby, ...byVilarejo];
  const seen = new Set<string>();
  return combined
    .filter((e: any) => {
      if (seen.has(e.id)) return false;
      seen.add(e.id);
      return true;
    })
    .slice(0, limit);
}

/** Parceiros com comissão */
export function getPartners(category: string, lang?: Lang): any[] {
  return getData(category, lang).filter((e: any) => e.provider?.commission?.length > 0);
}

/** Contagem */
export function getCount(category: string, lang?: Lang): number {
  return getPublished(category, lang).length;
}

/** Estatísticas */
export function getStats(lang?: Lang) {
  const categories = [
    'praia',
    'trilha',
    'atracao',
    'passeio',
    'pousada',
    'restaurante',
    'morro',
    'vila',
    'ilha',
    'trapiche',
  ];
  const counts = categories.reduce((acc: any, cat: string) => {
    acc[cat] = getPublished(cat, lang).length;
    return acc;
  }, {});

  return {
    total: Object.values(counts).reduce((a: any, b: any) => a + b, 0),
    byCategory: counts,
    partners: {
      passeio: getPartners('passeio', lang).length,
      pousada: getPartners('pousada', lang).length,
      restaurante: getPartners('restaurante', lang).length,
    },
  };
}

// Exports diretos (sempre pt-BR — usar getData para i18n)
export {
  praiasData as praias,
  trilhasData as trilhas,
  atracoesData as atracoes,
  passeiosData as passeios,
  pousadasData as pousadas,
  restaurantesData as restaurantes,
  morrosData as morros,
  vilasData as vilas,
  ilhasData as ilhas,
  trapichesData as trapiches,
};

// WhatsApp URL com tracking
export function getWhatsAppUrl(phone: string, message: string, source: string = 'site'): string {
  const cleanPhone = phone.replace(/\D/g, '');
  const utmMessage = `${message}\n\n(via vemprailhadomel.com.br — ${source})`;
  const encoded = encodeURIComponent(utmMessage);
  return `https://wa.me/55${cleanPhone}?text=${encoded}`;
}
